export default { sha: 'b346ee320766fcaf6d48aa5403ea74cfa620ed25', buildNumber: 'undefined' }
